import { render, staticRenderFns } from "./CasePrioritiesGrid.vue?vue&type=template&id=36b304d5&"
import script from "./CasePrioritiesGrid.vue?vue&type=script&lang=js&"
export * from "./CasePrioritiesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports